<template>
  <span>There was an error validating your parameters. If the issue persists please <p-link href="https://github.com/PrefectHQ/prefect/issues/new/choose">report an issue.</p-link></span>
</template>